/**
 * Replace `{code}` placeholders in free text with the tag's value.
 * Tags without a value keep their placeholder so missing data stays visible
 * to producers; pass `stripUnresolved: true` for client-facing output where
 * an unresolved placeholder should not appear at all.
 */
export function substituteTags(text, tags, options) {
    if (!text)
        return '';
    const substituted = tags.reduce((acc, tag) => {
        const placeholder = `{${tag.code}}`;
        return acc.split(placeholder).join(tag.value ?? placeholder);
    }, text);
    if (!options?.stripUnresolved)
        return substituted;
    // Remove any placeholder-looking leftovers ({word}) and tidy spacing.
    return substituted
        .replace(/\{[A-Za-z0-9_-]+\}/g, '')
        .replace(/[^\S\n]{2,}/g, ' ')
        .trim();
}
//# sourceMappingURL=tags.js.map